<p class="section-description">
  Both real app-creation steps against an access-good but version-behind sync pair: the template-choice step that asks
  whether to update, then the connect page a customer reaches by choosing
  <strong>Update templates</strong>. The choice step's CONTINUE always proceeds; the connect page's stays disabled until
  the templates are current, which is why it renders greyed here. Pick a flow to review each one — they render entirely
  different step cards, and Azure also changes the choice step's copy. Clicking CONTINUE on the choice step navigates
  into the real creation flow and leaves the test page.
</p>
<div class="stacksets-scenario-controls">
  <label class="stacksets-scenario-picker">
    <span class="stacksets-scenario-picker-label">Flow</span>
    <select class="arpio-select" (change)="setLegacyTemplateFlow($any($event.target).value)">
      <option value="cloudformation" [selected]="legacyTemplateFlow === 'cloudformation'">AWS — CloudFormation</option>
      <option value="stacksets" [selected]="legacyTemplateFlow === 'stacksets'">AWS — StackSets</option>
      <option value="azure" [selected]="legacyTemplateFlow === 'azure'">Azure</option>
    </select>
  </label>
  <p class="stacksets-scenario-description">{{ legacyTemplateFlowDescription }}</p>
</div>
@if (legacyTemplateMounted) {
  <h4 class="resource-status-subheader">Step 1 — the choice</h4>
  <application-creator-template-choice-page></application-creator-template-choice-page>
  <h4 class="resource-status-subheader">Step 2 — the connect page, after choosing to update</h4>
  <application-creator-connect-page></application-creator-connect-page>
}
